export const frReportTranslations = {
  'report.modal.title': 'Génération du bilan de campagne',
  'report.modal.error.title': 'Erreur',
  'report.modal.error.text':
    "Une erreur s'est produite durant la génération du rapport",
  'report.modal.selector.text':
    'La génération d’un bilan de campagne peut prendre plusieurs minutes. Un téléchargement automatique sera déclenché une fois l’opération terminée.',
  'report.modal.error.button': 'Fermer',
  'report.modal.button': 'Télécharger',
};
